import axios from 'axios'
import { toODataString } from '@progress/kendo-data-query'
import { getAccessToken } from 'utils/accessToken'
import { constants } from 'consts'

const toODataQuery = (request) => {
  return toODataString(request, { utcDates: true })
}
const processResponse = response => Promise.resolve(response.data)
const options = (timeout, contentType = 'application/json') => {
  return Object.assign({}, {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`,
      'Content-Type': contentType }
    }, (timeout ? { timeout } : {}))
}

const httpClient = axios.create({ baseURL: constants.API_BASE_URI })
httpClient.defaults.timeout = 30000

const lookupApiMethods = (name) => ({
  get: (request) => httpClient.get(`/odata/${name}Lookup?$count=true&${toODataQuery(request)}`, options()),
})

const apiMethods = (name) => ({
  get: (request) => httpClient.get(`/odata/${name}?$count=true&${toODataQuery(request)}`, options()),
  getEntity: (id) => httpClient.get(`/api/services/app/${name}/Get?id=${id}`, options()).then(r => processResponse(r)),
  update: (entity) => httpClient.put(`/api/services/app/${name}/Update`, entity, options()).then(r => processResponse(r)), // override PUT
  updateAll: (x) => httpClient.put(`/api/services/app/${name}/UpdateAll`, x, options()).then(r => processResponse(r)), // override PUT
  create: (entity) => httpClient.post(`/api/services/app/${name}/Create`, entity, options()).then(r => processResponse(r)), // override PUT
  delete: (id) => httpClient.delete(`/api/services/app/${name}/Delete?id=${id}`, options()).then(r => processResponse(r)),
})

const softDeleteApiMethods = (name) => ({
  ...apiMethods(name),
  getDeleted: (request) => httpClient.get(`/odata/Deleted${name}?$count=true&${toODataQuery(request)}`, options()),
  restore: (id) => httpClient.post(`/api/services/app/${name}/Restore?id=${id}`, null, options()).then(r => processResponse(r)),
  hardDelete: (id) => httpClient.post(`/api/services/app/${name}/HardDelete?id=${id}`, null, options()).then(r => processResponse(r)),
  emptyTrash: () => httpClient.post(`/api/services/app/${name}/EmptyTrash`, null, options(120000)).then(r => processResponse(r)),
})

export default {
  lookupApiMethods,
  apiMethods,
  softDeleteApiMethods,
  httpClient,
  processResponse,
  options
}
